import { createContext } from "react"

const WhitneyHtml = createContext()

export default WhitneyHtml
